import React from 'react'
import { Flex, Text } from 'chemistry'
import { StarSvg } from 'client/common/components/StarSvg/StarSvg'
import { dictionary } from 'client/common/accessability'

export const StarRating = ({ rating, label, lang }) => {
  const boxHeight = '24px'
  let ariaLabel = `${rating} ${dictionary(lang).outOf} 5`
  if (label) ariaLabel += ` ${label}`

  return (
    <Flex height={boxHeight} justify='center' aria-label={ariaLabel}>
      <Flex padding='4px'>
        {Array.from(Array(5).keys()).map((_, index) => {
          const starIndex = index + 1
          return (
            <StarSvg
              key={`star${starIndex}`}
              id={`star${starIndex}-filter${rating}`}
              prominent={starIndex <= rating}
              offsetValue={'100%'}
            />
          )
        })}
      </Flex>
      {Boolean(label) && <Text lineHeight={boxHeight}>{label}</Text>}
    </Flex>
  )
}
